import {
	numberScopes,
	type NumberValue,
} from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/number.tsx';

export type InternalNumberValue = string | '' | undefined;

export const transformNumberToInternalValue = (publicValue: NumberValue): InternalNumberValue =>
	publicValue === null ? '' : String(publicValue);

export const transformNumberToPublicValue = (internalValue: InternalNumberValue): NumberValue =>
	[undefined, ''].includes(internalValue) ? null : Number(internalValue);

export const numberIssueGicScopes = {
	...numberScopes,
	granular: [...numberScopes.granular, 'write:field.default-value:jira'],
};
